import type { Client, Home, Xapi } from '@efdigital/ll-addon-data';
import { setAsyncHasMany } from '@efdigital/ll-admin-v2/data/async-setter';
import { findClient } from '@efdigital/ll-admin-v2/data/builders/system/clients';
import { queryHome } from '@efdigital/ll-admin-v2/data/builders/system/homes';
import { queryXapi } from '@efdigital/ll-admin-v2/data/builders/system/xapi';
import Route from '@ember/routing/route';
import { service } from '@ember/service';
import type { Store } from '@warp-drive/core';

export interface LibraryClientsEditModel {
  client: Client;
  xapi: Xapi | null;
  home: Home | null;
}

export default class LibraryClientsClientRoute extends Route {
  @service declare store: Store;

  async model(params: { client_id: string }): Promise<LibraryClientsEditModel> {
    const client = (await this.store.request(findClient(params.client_id)))
      .content.data;

    if (!client.subscription || client.subscription === 'standard') {
      client.subscription = 'full';
    }

    let xapi: Xapi | null = null;
    try {
      const xapiResponse = await this.store.request(
        queryXapi(params.client_id)
      );
      const xapis = xapiResponse.content.data;
      xapi = xapis.length > 0 ? xapis[0]! : null;
    } catch (e) {
      console.warn('Failed to load xapi:', e);
    }

    // Load or create Home record
    let home: Home | null = null;
    try {
      const homeResponse = await this.store.request(
        queryHome(params.client_id)
      );
      const homes = homeResponse.content.data;

      if (homes.length > 0) {
        home = homes[0]!;
      } else {
        // Create new home record if none exists
        home = this.store.createRecord('homes', {
          client,
        }) as Home;
      }

      if (home) {
        if (!(await home.mappers)) {
          setAsyncHasMany(home, 'mappers', []);
        }

        if (!(await home.comps)) {
          setAsyncHasMany(home, 'comps', []);
        }
      }
    } catch (e) {
      console.warn('Failed to load home:', e);
    }
    return {
      client,
      xapi,
      home,
    };
  }
}
